import { css } from '@emotion/react';
import { breakpoint_large, breakpoint_macbook_small } from '../../../../../shared/constants/breakpoints';
import { color_shades_light, voicify_spark_medium } from '../../../../../shared/constants/colors';

export const sidebarBodyTypography = css`
    font-family: inherit;
    font-size: 11px;
    font-weight: 500;
    line-height: 1.4;

    ${breakpoint_macbook_small} { font-size: 10px; }
    ${breakpoint_large} { font-size: 9px; }
`;

export const sidebarCaptionTypography = css`
    font-family: inherit;
    font-size: 10px;
    font-weight: 600;
    line-height: 1.4;

    ${breakpoint_macbook_small} { font-size: 9px; }
    ${breakpoint_large} { font-size: 8px; }
`;

export const sidebarFieldStyles = css`
    box-sizing: border-box;
    min-height: 30px;
    padding: 6px 10px;
    border: 1px solid ${color_shades_light};
    border-radius: 8px;

    ${breakpoint_macbook_small} {
        min-height: 28px;
        padding: 5px 8px;
    }

    ${breakpoint_large} {
        min-height: 26px;
        padding: 4px 8px;
    }
`;

export const sidebarFocusStyles = css`
    &:focus-visible {
        outline: 2px solid ${voicify_spark_medium};
        outline-offset: -2px;
    }
`;

export const sidebarFieldFocusStyles = css`
    &:focus, &:focus-within {
        outline: none;
        border-color: ${voicify_spark_medium};
        box-shadow: inset 0 0 0 1px ${voicify_spark_medium};
    }
`;
